import React from 'react';
import { Link } from 'gatsby';
import Config from '../config';
import ViktoriaLink from './viktorialink';

const SubmenuList = (props) => {
    const routes = Config.Services.ProductRoutes;
    return (
        <div className="d-none d-lg-block">
            <div className="col-12 text-center">
                <ul className="list-inline service-inner-navigation">
                    <li className={props.activePath === routes.featuredProducts ? 'list-inline-item active pr-0 pl-0' : 'list-inline-item pr-0 pl-0'}>
                        <ViktoriaLink activeClassName="active" exact="true" to={routes.featuredProducts}>Featured Products </ViktoriaLink>
                    </li>
                    <li className={props.activePath === routes.hunterDouglasWindowFashions ? 'list-inline-item pr-0 active' : 'list-inline-item pr-0'}>
                        <Link to={routes.hunterDouglasWindowFashions}>Hunter Douglas Window Fashions</Link>
                    </li>
                    <li className={props.activePath === routes.bedBathAndKitchen ? 'list-inline-item pr-0 active' : 'list-inline-item pr-0'}>
                        <Link to={routes.bedBathAndKitchen}>Bed, Bath And Kitchen</Link>
                    </li>
                    <li className={props.activePath === routes.homeDecor ? 'list-inline-item pr-0 active' : 'list-inline-item pr-0'}>
                        <Link to={routes.homeDecor}>Home Decor</Link>
                    </li>
                    <li className={props.activePath === routes.patioAwningsShadesAndDrapers  ? 'list-inline-item pr-0 active' : 'list-inline-item pr-0'}>
                        <Link to={routes.patioAwningsShadesAndDrapers}>Patio Awnings, Shades And Drapes</Link>
                    </li>
                    <li className={props.activePath === routes.windowTreatments  ? 'list-inline-item pr-0 active' : 'list-inline-item pr-0'}>
                        <Link to={routes.windowTreatments}>Window treatments</Link>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default SubmenuList;